import React from 'react'
import {useSelector} from 'react-redux';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom'
import {Routes} from "../routes";

import TestPage from './pages/Test'
import LoginPage from './pages/Login'
import {withHome} from "./components/PSHome";
import HomePage from './pages/Home'
import GalleryPage from './pages/Gallery'
import NewsPage from './pages/News'
import NewsItemPage from './pages/NewsItem'
import ProductsPage from './pages/Products'
import ProductItemPage from './pages/ProductItem'
import ContactPage from './pages/Contact'
import {urlOrg} from "./shared/constants/Constants";


const RoutesPage = (props) => {
  const { errorLogin } = useSelector((state) => state.user);
  const idOrgCurrent = localStorage.getItem('idOrg');

  const url = idOrgCurrent ? urlOrg[idOrgCurrent].url: '';

  const PrivateRoute = ({ component, path, ...rest }) => {
    if (errorLogin === null) {
      return <Route component={component} path={path} {...rest} />;
    }
      return <Redirect to={`${Routes.LOGIN}/${url}`} {...rest} />;

  };

  return (
    <Router>
      <Switch>
        <Route exact path="/" render={() => <Redirect to={Routes.LOGIN} />} />
        <Route Route path={`${Routes.LOGIN}/:id`} component={LoginPage}/>
        <PrivateRoute path={Routes.TEST} exact component={withHome(TestPage)}/>
        <PrivateRoute path={Routes.HOME} exact component={withHome(HomePage)}/>
        <PrivateRoute path={Routes.CMS_NEW} exact component={withHome(NewsPage)}/>
        <PrivateRoute path={Routes.CMS_NEWS_ITEM} exact component={withHome(NewsItemPage)}/>
        <PrivateRoute path={`${Routes.CMS_NEWS_ITEM}/:id`}  component={withHome(NewsItemPage)}/>
        <PrivateRoute path={Routes.CMS_GALLERY} exact component={withHome(GalleryPage)}/>
        <PrivateRoute path={Routes.CMS_PRODUCTS} exact component={withHome(ProductsPage)}/>
        <PrivateRoute path={Routes.CMS_PRODUCT_ITEM} exact component={withHome(ProductItemPage)}/>
        <PrivateRoute path={`${Routes.CMS_PRODUCT_ITEM}/:id`}  component={withHome(ProductItemPage)}/>
        <PrivateRoute path={Routes.CMS_CONTACTS} exact component={withHome(ContactPage)}/>
      </Switch>
    </Router>
  )
};

export default RoutesPage
